export default {
  active: 'Active',
  inactive: 'Inactive',
  never: 'Never',
  allStatuses: 'All statuses',
  filterByStatus: 'Filter by status',
  colAssignedTo: 'Assigned to',
  assign: 'Assign',
  creating: 'Creating…',
  saved: 'Saved.',
  assetStatusAvailable: 'Available',
  assetStatusAssigned: 'Assigned',
  assetStatusRetired: 'Retired',
  assetsTitle: 'Assets',
  assetsDescription: 'Company equipment and who has it. Assign kit to employees and mark it returned when they leave.',
  addAsset: 'Add asset',
  register: 'Register',
  searchAssets: 'Search assets',
  searchAssetsPlaceholder: 'Search name or serial',
  filterByCategory: 'Filter by category',
  allCategories: 'All categories',
  needsAttention: 'Needs attention',
  noAssets: 'No assets',
  noAssetsMessage: 'Add laptops, phones, tools and vehicles to keep track of who has them.',
  colAsset: 'Asset',
  colCategory: 'Category',
  colRenewals: 'Renewals and service',
  sinceDate: 'since {date}',
  details: 'Details',
  return: 'Return',
  beaconsTitle: 'Beacons',
  beaconsDescription: 'Bluetooth tags for people and tools, and the gateways at each site that detect them.',
  addTag: 'Add tag',
  addGateway: 'Add gateway',
  tags: 'Tags',
  gateways: 'Gateways',
  noTags: 'No tags',
  noTagsMessage: 'Add each tag by its MAC address, then assign it to a person or a tool.',
  colTag: 'Tag',
  person: 'Person',
  personSince: 'Person, since {date}',
  asset: 'Asset',
  assetSince: 'Asset, since {date}',
  unassigned: 'Unassigned',
  reassign: 'Reassign',
  unassign: 'Unassign',
  tagUnassigned: 'Tag unassigned.',
  noGateways: 'No gateways',
  noGatewaysMessage: 'Register a gateway by its hardware ID and assign it to the site it covers.',
  colGateway: 'Gateway',
  colSite: 'Site',
  colLastHeard: 'Last heard',
  perfTitle: 'Performance',
  perfDescription: 'Run review periods, track goals and set what reviews rate. Notes, disciplinary records and the 9-box live on each employee.',
  perfReviews: 'Reviews',
  perfGoals: 'Goals',
  perfCriteria: 'Criteria',
  perfPeriods: 'Review periods',
  perfNewPeriod: 'New period',
  perfNoPeriods: 'No review periods',
  perfNoPeriodsMessage: 'Create a period, then launch it to start a draft review for every active employee.',
  perfOpen: 'Open',
  perfClosed: 'Closed',
  perfPeriodSummary: '{from} to {to} · {submitted} of {total} submitted',
  perfShowing: 'Showing',
  perfShowReviews: 'Show reviews',
  perfEveryoneHasReview: 'Everyone already has a review.',
  perfReviewsCreatedOne: '{count} review created.',
  perfReviewsCreatedOther: '{count} reviews created.',
  perfLaunchReviews: 'Launch reviews',
  perfPeriodClosed: 'Period closed.',
  perfPeriodReviews: '{name} reviews',
  perfNoReviews: 'No reviews in this period',
  perfNoReviewsMessage: 'Launch the period to create a draft review for each active employee.',
  perfSubmittedAverage: 'Submitted, average {average} of 5',
  perfDraftRated: 'Draft, {rated} of {total} rated',
  perfView: 'View',
  perfRate: 'Rate',
  perfPeriodCreated: 'Review period created.',
  perfNewPeriodTitle: 'New review period',
  perfPeriodPlaceholder: 'e.g. H2 2026',
  perfStarts: 'Starts',
  perfEnds: 'Ends',
  goalNotStarted: 'Not started',
  goalInProgress: 'In progress',
  goalDone: 'Done',
  goalCancelled: 'Cancelled',
  perfCreateGoal: 'Create goal',
  perfNoGoals: 'No goals',
  perfNoGoalsMessage: 'Create goals for individuals or teams and track progress here.',
  perfCriteriaTitle: 'Review criteria',
  perfAddCriterion: 'Add criterion',
  perfEditCriterion: 'Edit criterion',
  perfCriteriaHint: 'Each criterion is rated 1 to 5. A review keeps the criteria that were active when its period was launched.',
  perfDescriptionOptional: 'Description (optional)',
}
